import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarDays } from 'lucide-react';
import { newsAPI } from '@/services/newsService';
import { getImageUrl } from '@/services/api';
import MediaNavTabs from '@/components/MediaNavTabs';

const News = () => {
  const [newsItems, setNewsItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await newsAPI.listPublic();
        setNewsItems(res.data || []);
      } catch (error) {
        console.error('Failed to load news:', error);
        setNewsItems([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const formatDate = (value) => {
    if (!value) return '-';
    return new Date(value).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="relative mt-16 sm:mt-20">
        {/* Hero banner */}
        <div className="w-full py-10 sm:py-16" style={{ background: 'linear-gradient(90deg, #BFB4EE 0%, #B3FFD1 100%)' }}>
          <div className="max-w-7xl mx-auto px-4">
            <h1 className="text-center text-3xl sm:text-4xl md:text-5xl font-bold" style={{ color: '#533192', fontFamily: 'Prompt' }}>
              สื่อและข่าวสาร
            </h1>
          </div>
        </div>

        <MediaNavTabs />
        <div className="w-full h-1.5" style={{ background: '#533193' }} />
      </div>

      <div className="max-w-7xl mx-auto px-4 py-8 sm:py-12">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-6 sm:mb-8 text-center" style={{ fontFamily: 'Prompt' }}>
          ข่าวสาร
        </h2>

        {loading ? (
          <div className="h-48 flex items-center justify-center text-gray-500">กำลังโหลดข่าว...</div>
        ) : newsItems.length === 0 ? (
          <div className="text-center py-16 bg-white border rounded-2xl">
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-700">ยังไม่มีข่าวสาร</h3>
            <p className="text-gray-500 mt-2 text-sm sm:text-base">เมื่อมีการเผยแพร่ข่าวใหม่ จะแสดงที่หน้านี้อัตโนมัติ</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
            {newsItems.map((news) => (
              <Link key={news.id} to={`/news/${news.id}`} className="group w-full">
                <div className="relative rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-500 hover:scale-[1.02] hover:-translate-y-1">
                  <div className="absolute inset-0">
                    <img
                      src={getImageUrl(news.cover_image_url)}
                      alt={news.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-purple-900/80" />
                  </div>

                  <div className="relative h-[280px] sm:h-[360px] md:h-[420px] flex flex-col justify-end p-4 sm:p-5 md:p-6">
                    <div className="space-y-2 sm:space-y-3">
                      <span className="inline-flex rounded-full border border-white/60 text-white text-xs px-3 py-1">
                        {news.category || 'ข่าวสาร'}
                      </span>
                      <h3 className="text-base sm:text-lg md:text-xl font-bold text-white line-clamp-2">{news.title}</h3>
                      <p className="text-white/90 text-xs sm:text-sm line-clamp-2 sm:line-clamp-3">
                        {news.excerpt || 'คลิกเพื่ออ่านรายละเอียดเพิ่มเติม'}
                      </p>
                      <div className="flex items-center justify-between">
                        <span className="inline-flex items-center gap-1 text-xs sm:text-sm text-white/80">
                          <CalendarDays className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
                          {formatDate(news.publish_date)}
                        </span>
                        <span className="w-9 h-9 sm:w-11 sm:h-11 bg-purple-600 rounded-full flex items-center justify-center hover:bg-purple-700 transition-colors flex-shrink-0">
                          <span className="w-0 h-0 border-l-[6px] sm:border-l-[7px] border-l-white border-t-[4px] sm:border-t-[5px] border-t-transparent border-b-[4px] sm:border-b-[5px] border-b-transparent ml-0.5" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default News; 